// noinspection JSCheckFunctionSignatures,ES6CheckImport
import {Provider} from "@oilstone/container";
import {createRouter, createWebHistory} from 'vue-router';
import { trackRouter } from "vue-gtag-next";
import webRoutes from "@/apps/web/routes";
import cmsRoutes from "@/apps/cms/routes";
import Kernel from "@oilstone/kernel";

export default new Provider().register(container => {
    container.singleton('router', () => {
        let isLoggedIn = false;

        const router = createRouter({
            history: createWebHistory(process.env.BASE_URL),
            routes: webRoutes.concat(cmsRoutes)
        });

        const context = {
            app: null,
            preview: false,
        };

        const loggedIn = async () => {
            try {
                await container.resolve('vuexStore').dispatch('auth/loggedIn');

                return true;
            } catch (e) {
                //
            }

            return false;
        }

        container.add('context', context);

        router.beforeEach(async (to) => {
            // forgetDataLayer();

            // The use of a timeout here is an far from desirable "fix" for mobiles that will ignore the scrollTo call otherwise
            setTimeout(() => {
                window.scrollTo({top: 0, behavior: 'smooth'});
            }, 0);

            if (to.path.startsWith('/admin')) {
                context.app = 'cms';

                if (to.meta.noAuth) {
                    return;
                }

                isLoggedIn = await loggedIn();

                if (!isLoggedIn) {
                    return '/admin/login'
                }
            } else {
                const store = Kernel.resolve('vuexStore');
                context.app = 'web';

                if (typeof to.query.preview !== 'undefined') {
                    isLoggedIn = await loggedIn();

                    if (isLoggedIn) {
                        context.preview = true;
                    }
                }

                if (store.getters['tracker/shouldShowCookiePrompt']) {
                    store.dispatch('tracker/showCookiePrompt', true);
                }
            }
        });

        trackRouter(router);

        return router;
    });
});
